import React from 'react';
import { EyeIcon, ClockIcon, BadgeCheck } from 'lucide-react';
const HeaderGlpPlateau1 = () => {
  return <header className="bg-white" style={{
    fontFamily: 'Georgia, Cambria, "Times New Roman", serif'
  }} data-id="element-17930" data-mp="1qt3x8m3jyqh3">
      {/* Top black bar */}
      <div className="bg-black h-3 w-full" data-id="element-17931" data-mp="1cux7xuco5yt1"></div>

      {/* Masthead section */}
      <div className="border-b border-gray-800 px-4 sm:px-6 py-4 sm:py-6" data-id="element-17932" data-mp="1hsyr0fa3hy4i">
        <div className="text-center pb-3 sm:pb-4 mb-3 sm:mb-4" data-id="element-17933" data-mp="25hhxcp9l40ty">
          <h2 className="font-serif text-2xl sm:text-3xl font-bold tracking-tight text-gray-900" data-id="element-17934" data-mp="25k46gtc4ioea">
            TRADITIONAL MEDPUB
          </h2>
          <div className="text-xs uppercase tracking-widest text-gray-500 mt-2 font-medium" data-id="element-17935" data-mp="1vqvp5g476cla">
            INDEPENDENT HEALTH INVESTIGATIONS SINCE 1982
          </div>
        </div>

        <div className="flex flex-col sm:grid sm:grid-cols-3 text-xs text-gray-600 border-b border-gray-300 pb-2 gap-1 sm:gap-0" data-id="element-17936" data-mp="2og2mwcvtuy5h">
          <div className="text-left" data-id="element-17937" data-mp="2t8450ffofj3f">VOL. 128, NO. 43</div>
          <div className="text-left sm:text-center" data-id="element-17938" data-mp="s28z5xwjx0xd">
            {(() => {
            const yesterday = new Date();
            yesterday.setDate(yesterday.getDate() - 1);
            return yesterday.toLocaleDateString('en-US', {
              weekday: 'long',
              month: 'long',
              day: 'numeric',
              year: 'numeric'
            }).toUpperCase();
          })()}
          </div>
          <div className="text-left sm:text-right" data-id="element-17939" data-mp="1bpq71t9y6vlw">
            HEALTH & WELLNESS SECTION
          </div>
        </div>
      </div>

      {/* Article header */}
      <div className="px-4 sm:px-6 py-6 border-b border-gray-200" data-id="element-17940" data-mp="16trc1mu46fci">
        <div className="max-w-4xl mx-auto" data-id="element-17941" data-mp="1kqo0xiqo9mqr">
          <div className="uppercase text-xs tracking-wider text-gray-500 font-medium border-b border-gray-200 pb-2 mb-4" data-id="element-17942" data-mp="1fs39o8teedeg">
            GLP-1 NEWS
          </div>

          <h1 className="font-serif text-2xl sm:text-4xl font-bold text-gray-900 leading-tight mb-6" data-id="element-17943" data-mp="3mj2p2zjt7nfm">
            When GLP-1 Weight Loss Stalls: It's Not A Plateau. It's A "Safety
            Stop." Why Your Body Has Paused Weight Loss (And How To Signal The
            "All Clear").
          </h1>

          {/* Author Byline */}
          <div className="flex items-center gap-4 mb-6 pb-5 border-b border-gray-200" data-id="element-17944" data-mp="1veiquzdjaqkj">
            <div className="w-16 h-16 rounded-full overflow-hidden flex-shrink-0 bg-gray-200" data-id="element-17945" data-mp="1vgvjq7ktylcd">
              <img src="https://cdn.magicpatterns.com/uploads/rKaFbUnFVbMoxdhGqaKtZu/YOBfxHJfIQlDu4JngMJH0_HjPwLyqE.png" alt="Dr. Thomas Reed" className="w-full h-full object-cover" data-id="element-17946" data-mp="1ze00m4zzu9vi" />
            </div>
            <div className="flex-1" data-id="element-17947" data-mp="29bxlciin9ojd">
              <div className="flex items-center gap-2 mb-2" data-id="element-17948" data-mp="2e4qpp5a7auux">
                <span className="text-base font-medium text-gray-900" data-id="element-17949" data-mp="2e7cwv3t6j8cm">
                  Written by Dr. Thomas Reed
                </span>
                <BadgeCheck className="h-5 w-5 text-blue-600" data-id="element-17950" data-mp="2n6ggqa067rs6" />
              </div>
              <div className="text-sm text-gray-600 mb-2" data-id="element-17951" data-mp="2s4i95ljhl3gb">
                Verified Metabolic Health Specialist
              </div>
              <div className="flex items-center gap-4 text-sm text-gray-500" data-id="element-17952" data-mp="gi7qmrvh9zxo">
                <div className="flex items-center gap-1" data-id="element-17953" data-mp="bi26rxvg9hq5">
                  <ClockIcon className="h-4 w-4" data-id="element-17954" data-mp="bkodjvaint7b" />
                  <span data-id="element-17955" data-mp="7hrq9ra178x1">7 min read</span>
                </div>
                <div className="flex items-center gap-1" data-id="element-17956" data-mp="2hn8zz1aua5r">
                  <EyeIcon className="h-4 w-4" data-id="element-17957" data-mp="2j83xprizv45" />
                  <span data-id="element-17958" data-mp="z7o3meocnkuz">171,892 views</span>
                </div>
              </div>
            </div>
          </div>

          <div className="mb-6" data-id="element-17959" data-mp="v62iy75kq2a8"></div>

          <p className="text-lg font-medium text-gray-700 mb-6 leading-relaxed border-l-4 border-gray-800 pl-4" data-id="element-17960" data-mp="v7479dblol9w">
            Before you increase your dose, read this. If the scale has stopped
            moving, your body hasn't built a tolerance—it has hit a "stress
            threshold." Here is how to lower your biological threat level to
            restart fat burning without changing your prescription.
          </p>

          <div className="border-t border-gray-200 pt-3 mb-6 text-xs text-gray-500 flex flex-wrap justify-between" data-id="element-17961" data-mp="xpnsbvmtcocg">
            <div className="mb-1 flex items-center" data-id="element-17962" data-mp="12pa6c7agu8mb">
              <span className="font-medium mr-2" data-id="element-17963" data-mp="12q251qzd0mgt">Published by:</span>
              Traditional Medicine Publications
            </div>
            <div className="mb-1 flex items-center" data-id="element-17964" data-mp="tnstcxscun1u">
              <span className="font-medium mr-2" data-id="element-17965" data-mp="tom224avjmmm">Published:</span>
              January 2026
            </div>
          </div>
        </div>
      </div>
    </header>;
};
export default HeaderGlpPlateau1;